const sensors = [
  {
    id: 1,
    name: "Capacitive Level Sensor",
    description: "High accuracy liquid level detection.",
    image: "/assets/sensors/LS.png",
    pdf: "/assets/pdfs/sample.pdf",
    price: "₹1200"
  },
  {
    id: 2,
    name: "Ultrasonic Level Sensor",
    description: "Non-contact measurement for tanks.",
    image: "/assets/sensors/LS.png",
    pdf: "/assets/pdfs/sample.pdf",
    price: "₹1500"
  },
  {
    id: 3,
    name: "Radar Level Sensor",
    description: "Best for industrial level monitoring.",
    image: "/assets/sensors/LS.png",
    pdf: "/assets/pdfs/sample.pdf",
    price: "₹1800"
  }
];

export default sensors;
